import Menu from './menu';

export default class MenuTouchMobile extends Menu {

    constructor(...args) {
        super(...args);

        this._retrieveDOM();
    }

    _retrieveDOM() {
        super._retrieveDOM();
    }

    getChildrenHeight() {
        this._heightChildren = [];
        for( let i = 0, j = this.dom.containerChildren.length; i < j; i++ ) {
            let element = this.dom.containerChildren[i];
            let heightBlockChildren = element.getBoundingClientRect().height;
            this._heightChildren.push(heightBlockChildren);
            element.style.maxHeight = 0;
        }
    }

    /*
     init() {
     }
     bind() {
     }
     unbind() {
     }
     resize(width, height) {
     }
     */
}



// WEBPACK FOOTER //
// src/js/components/menu/menu.mobile.js